import React from 'react';
import Slider from 'react-slick';

const brandImages = [
  '/images/about/availibility.jpg',
  '/images/about/fair-pricing.jpg',
  '/images/about/safety.jpg',
  '/images/about/security.jpg',
  '/images/about/time.jpg',
  '/images/about/carmaintain.jpg',
];

const OurPartnersSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      }
    ]
  };

  return (
    <section
      className="elementor-section elementor-top-section bg-row-theme row-top"
      style={{ overflowX: 'hidden' }} // 👈 Prevent horizontal scroll
    >
      <div
        className="elementor-container elementor-column-gap-default"
        style={{ overflowX: 'hidden' }} // 👈 Also apply to inner container
      >
        {/* Left column: heading */}
        <div className="elementor-column elementor-col-50">
          <div className="elementor-widget-wrap">
            <div className="elementor-widget">
              <div className="elementor-widget-container">
                <div className="gva-element-gva-heading-block gva-element">
                  <div className="align-left style-2 widget gsc-heading box-align-left auto-responsive">
                    <div className="brand-one__title">
                      <h2 className='p-4'>Our Qualities</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right column: brand logos carousel */}
        <div className="elementor-column elementor-col-50">
          <div className="elementor-widget-wrap">
            <div className="elementor-widget">
              <div className="elementor-widget-container">
                <div className="gva-element-gva-brand gva-element">
                  <div className="gva-brand-carousel style-1">
                    <Slider {...settings}>
                      {brandImages.map((src, index) => (
                        <div key={index} className="brand-item">
                          <div className="brand-item-content">
                            <img
                              src={src}
                              alt={`brand-${index + 1}`}
                              className="brand-img"
                              style={{
                                maxWidth: '100%',
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto'
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default OurPartnersSection;
